import { createContext, useContext } from 'react';
import { defaultConfig, MODE } from './config';
export var DarkModeContext = createContext({
    autoModeActive: true,
    autoModeSupported: true,
    darkModeActive: defaultConfig.defaultMode === MODE.DARK,
    switchToAutoMode: function () { },
    switchToDarkMode: function () { },
    switchToLightMode: function () { },
});
DarkModeContext.displayName = 'DarkMode';
export var useDarkMode = function () {
    var context = useContext(DarkModeContext);
    if (context === undefined) {
        throw new Error('useDarkMode must be used within a DarkModeContext Provider');
    }
    return context;
};
//# sourceMappingURL=darkModeContext.js.map